import {
  Globe, LayoutDashboard, Smartphone, PenTool, BrainCircuit, Workflow, Megaphone,
  Search, Palette, ShoppingCart, Cog, Lightbulb, Sparkles, ShieldCheck, Rocket, Zap,
} from "lucide-react";

const MAP = {
  Globe, LayoutDashboard, Smartphone, PenTool, BrainCircuit, Workflow, Megaphone,
  Search, Palette, ShoppingCart, Cog, Lightbulb, Sparkles, ShieldCheck, Rocket, Zap,
};

export default function Icon({ name, className = "h-6 w-6" }) {
  const Cmp = MAP[name] || Sparkles;
  return <Cmp className={className} />;
}
